var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-layout', {
    attrs: {
      "justify-center": ""
    }
  }, [_c('v-responsive', {
    staticClass: "mx-n3 px-3",
    attrs: {
      "width": "100%",
      "height": "100%"
    }
  }, [_c('list-heading', {
    attrs: {
      "title": "자재연결 상세"
    }
  }), _c('v-row', {
    staticClass: "ma-n2"
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "lg": "4"
    }
  }, [_c('v-row', {
    staticClass: "ma-n2",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('manufacturing-material-basic', _vm._b({
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        var _vm$material, _vm$material2;

        return [_c('v-layout', {
          staticClass: "my-n3"
        }, [_c('v-btn', {
          attrs: {
            "small": "",
            "text": "",
            "fab": "",
            "tile": "",
            "color": "grey"
          }
        }, [_c('v-icon', [_vm._v("mdi-home")])], 1), (_vm$material = _vm.material) !== null && _vm$material !== void 0 && _vm$material.href ? [_c('v-btn', {
          attrs: {
            "small": "",
            "text": "",
            "fab": "",
            "tile": "",
            "color": "info",
            "href": _vm.material.href,
            "target": "_blankreset ."
          }
        }, [_c('v-icon', [_vm._v("mdi-store")])], 1)] : _vm._e(), (_vm$material2 = _vm.material) !== null && _vm$material2 !== void 0 && _vm$material2.sheet ? [_c('v-btn', {
          attrs: {
            "small": "",
            "text": "",
            "fab": "",
            "tile": "",
            "color": "info",
            "href": _vm.material.sheet,
            "target": "_blankreset ."
          }
        }, [_c('v-icon', [_vm._v("mdi-file-pdf-box")])], 1)] : _vm._e(), _c('manufacturing-material-search', _vm._g(_vm._b({
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function fn(_ref) {
              var attrs = _ref.attrs,
                  on = _ref.on;
              return [_c('v-btn', _vm._g(_vm._b({
                attrs: {
                  "small": "",
                  "text": "",
                  "fab": "",
                  "tile": "",
                  "color": "primary"
                }
              }, 'v-btn', attrs, false), on), [_c('v-icon', [_vm._v("mdi-link-variant-plus")])], 1)];
            }
          }])
        }, 'manufacturing-material-search', {
          material: _vm.material
        }, false), {
          updateLinkItem: _vm.updateLinkItem
        }))], 2)];
      },
      proxy: true
    }])
  }, 'manufacturing-material-basic', {
    loading: _vm.loading,
    material: _vm.material
  }, false))], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('manufacturing-material-brief', _vm._b({}, 'manufacturing-material-brief', {
    loading: _vm.loading,
    material: _vm.material
  }, false))], 1)], 1)], 1), _c('v-col', {
    staticClass: "pa-2",
    attrs: {
      "cols": "12",
      "lg": "8"
    }
  }, [_c('manufacturing-material-links', _vm._g(_vm._b({}, 'manufacturing-material-links', {
    material: _vm.material
  }, false), {
    updateLinkItem: _vm.updateLinkItem,
    init: _vm.init
  }))], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }